import cx from "clsx";
import React from "react";

import { useFieldListingPrice } from "./hooks";
import styles from "./index.module.scss";

import InputLovelaceAmount from "@/modules/kreate-modals/components/InputLovelaceAmount";

type Props = {
  className?: string;
  style?: React.CSSProperties;
  api: ReturnType<typeof useFieldListingPrice>;
  disabled?: boolean;
};

export default function FieldListingPrice({
  className,
  style,
  api,
  disabled,
}: Props) {
  return (
    <div className={cx(styles.container, className)} style={style}>
      <InputLovelaceAmount
        label="Listing Price"
        value={api.draft}
        onChange={api.setDraft}
        onBlur={api.validateAfterEditing}
        placeholder="ADA"
        tooltip="The price of each Edition you list. You can use decimal points here, too."
        error={api.error}
        disabled={disabled}
      />
    </div>
  );
}
